import { RecurringDecisionMedicine } from "src/types/Requests/MobRecurringRequests"
import MedicineInfoItem from "./MedicineInfoItem"
import "./style.css"

interface IMedicineCardContent {
    medicine: RecurringDecisionMedicine
}

const MedicineCardContent = ({ medicine }: IMedicineCardContent) => {
    return (
        <div className="medicine-card-content">
            <div className="medicine-info-grid">
                <MedicineInfoItem
                    label="amount"
                    value={medicine.amount}
                />
                <MedicineInfoItem
                    label="price"
                    value={medicine.price.toFixed(2)}
                />
                <MedicineInfoItem
                    label="patientCostShare"
                    value={medicine.patientCostShare.toFixed(2)}
                />
                <MedicineInfoItem
                    label="availableStock"
                    value={medicine.availableStock}
                    variant={medicine.availableStock === 0 ? "out-of-stock" : "in-stock"}
                />
                <MedicineInfoItem
                    label="availableDonatedStock"
                    value={medicine.availableDonatedStock}
                />

            </div>
        </div >
    )
}

export default MedicineCardContent

